import { db } from '@/plugins/firebase'
import { getDocs, collection, query, orderBy, limit, where, doc, deleteDoc } from 'firebase/firestore'
import { ActionContext } from 'vuex';
import moment from 'moment';
import { RootState } from '@/store/index';
import { WordCount, WordCountsState } from '@/models/models'

const state = {
	wordCounts: [],
};

const mutations = {
	setWordCounts(state: WordCountsState, wordCounts: WordCount[]) {
		state.wordCounts = wordCounts;
	},
	removeWordCount(state: WordCountsState, wordCountId: string) {
		state.wordCounts = state.wordCounts.filter(w => w.id !== wordCountId);
	}
};

const actions = {
	async fetchWordCounts({ commit }: ActionContext<WordCountsState, RootState>, uid: string) {
		const wordCountsRef = collection(db, `users/${uid}/word_counts`);
		const q = query(wordCountsRef, orderBy('created_at', 'desc'), limit(1));
		const querySnapshot = await getDocs(q);

		const wordCounts: WordCount[] = querySnapshot.docs.map(doc => ({
			id: doc.id,
			transcription_id: doc.data().transcription_id,
			created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/HH:MM'),
			teacher_word_count: doc.data().teacher_word_count,
			student_word_count: doc.data().student_word_count,
			lesson_date: moment(doc.data().lesson_date.toDate()).format('YYYY/MM/DD'),
		}));

		commit('setWordCounts', wordCounts);
	},

	async fetchWordCountsByDate({ commit }: ActionContext<WordCountsState, RootState>, { uid, date }: { uid: string, date: string }) {
		const wordCountsRef = collection(db, `users/${uid}/word_counts`);
		const stardOfDay = moment(date, 'YYYY/MM/DD').startOf('day').toDate();
		const endOfDay = moment(date, 'YYYY/MM/DD').endOf('day').toDate();

		const q = query(wordCountsRef,
			where('lesson_date', '>=', stardOfDay),
			where('lesson_date', '<', endOfDay));
		const querySnapshot = await getDocs(q);

		const wordCounts: WordCount[] = querySnapshot.docs.map(doc => ({
			id: doc.id,
			transcription_id: doc.data().transcription_id,
			created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/H:mm:ss'),
			teacher_word_count: doc.data().teacher_word_count,
			student_word_count: doc.data().student_word_count,
			lesson_date: moment(doc.data().lesson_date.toDate()).format('YYYY/MM/DD'),
		}));

		commit('setWordCounts', wordCounts);
	},

	async deleteWordCount({ commit }: ActionContext<WordCountsState, RootState>, { uid, wordCountId }: { uid: string, wordCountId: string }) {
		try {
			const wordCountsRef = doc(db, `users/${uid}/word_counts/${wordCountId}`);
			await deleteDoc(wordCountsRef);
			commit('removeWordCount', wordCountId);
		} catch (error) {
			console.error('Error deleting word count', error)
		}
	},
};

const getters = {
	wordCounts: (state: WordCountsState): WordCount[] => state.wordCounts,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
